<template>
  <div v-if="show" class="popup popup-alert">
    <div class="popup-container">
      <div class="popup-body">
        <div class="contents" v-html="message"></div>
        <div class="popup-footer">
          <div class="button-box">
            <button
              class="button primary"
              @click.stop="confirmEvent()"
              v-text="$t('confirm')"
            ></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@utils/bus';

export default {
  name: 'PopupAlert',
  props: {
    opened: false,
    message: '',
  },
  computed: {
    show: {
      get() {
        return this.opened;
      },
      set(value) {
        if (!value) {
          this.$emit('popupOff');
        }
      },
    },
  },
  methods: {
    confirmEvent() {
      this.show = false;
      EventBus.$emit('alert-confirm-event');
    },
  },
};
</script>

<style scoped lang="scss">
.popup.popup-alert {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.3);

  .popup-container {
    width: 100%;
    max-width: 360px;
    margin: 12px;
    border-radius: 3px;
    background-color: $white;

    .popup-footer {
      width: 100%;
    }

    .popup-body {
      width: 100%;
    }

    .contents {
      width: 100%;
      min-height: 120px;
      padding: 20px;
      font-size: 1.375em;
      line-height: 1.5em;
    }
  }
}
</style>
